import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Tip:`}</strong>{` We recommend using a '`}{`[object][verb]`}{`' format for your event names, where '`}{`[object]`}{`' is the entity that the behavior relates to, and '`}{`[verb]`}{`' is the behavior itself. For example, `}<inlineCode parentName="p">{`project created`}</inlineCode>{`, `}<inlineCode parentName="p">{`user signed up`}</inlineCode>{`, or `}<inlineCode parentName="p">{`invite sent`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      